exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ct-series-a .ct-line,.ct-series-a .ct-point{stroke:#ff9800}.ct-series-b .ct-line,.ct-series-b .ct-point{stroke:#e53935}.ct-label{font-size:12px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./src/components/Chart/Chart.css
// module id = 475
// module chunks = 0